import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstUrl'
})
export class FirstUrlPipe implements PipeTransform {

  transform(value: string): string {
    return value ? value.split(',', 1)[0] : '';
  }

}
